

  <h1 mat-dialog-title>{{"views.confirmationmodal.Confirmation!"| translate }}</h1>
<div mat-dialog-content>
  <p><p>{{"views.confirmationmodal.Are you sure to send activation link to all pending users?"| translate }}</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'views.confirmationmodal.No'| translate }}</button>
    <button mat-button color="primary" (click)="confirm()">{{'views.confirmationmodal.Yes'| translate }}</button>
</div>